import script from "./MyTestimony.vue?vue&type=script&setup=true&lang=js"
export * from "./MyTestimony.vue?vue&type=script&setup=true&lang=js"

import "./MyTestimony.vue?vue&type=style&index=0&id=4ca9447e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ca9447e"]])

export default __exports__